import { matchesSearch, LookupField, createLookupModel } from 'src/componentes/filtro/search-drawer/searchDrawerUtils';
import { Col, Row } from 'reactstrap';
import ToleranciaRiscoLookup from 'src/lookups/ToleranciaRiscoLookup';
import ToleranciaRiscoFaixasLookup from 'src/lookups/ToleranciaRiscoFaixasLookup';
import CollapsibleSection from 'src/componentes/CollapsibleSection';

const ToleranceSection = ({ model, resources, intl, searchQuery }) => {
  const fields = [
    {
      label: intl.formatMessage({ id: 'labelToleranciaRisco' }, {risco: resources.risco}),
      id: 'toleranciaRisco',
    },
    {
      label: intl.formatMessage({ id: 'labelToleranciaRiscoFaixas' }, {risco: resources.risco}),
      id: 'toleranciaRiscoFaixas',
    },
  ];

  const matchCount = fields.filter((field) =>
    matchesSearch(field.label, searchQuery)
  ).length;
  const visibleFields = fields.filter((field) =>
    matchesSearch(field.label, searchQuery)
  );

  if (!visibleFields.length && searchQuery) return null;

  return (
    <CollapsibleSection
      title={intl.formatMessage({ id: 'labelToleranciaRisco' }, {risco: resources.risco})}
      forceOpen={matchCount > 0 && searchQuery !== ''}
    >
      <Row>
        {visibleFields.includes(
          fields.find((f) => f.id === 'toleranciaRisco')
        ) && (
          <Col md={12}>
            <LookupField
              Component={ToleranciaRiscoLookup}
              clearable
              multi
              highlight={matchesSearch(
                intl.formatMessage({ id: 'labelToleranciaRisco' }, {risco: resources.risco}),
                searchQuery
              )}
              model={createLookupModel(
                intl.formatMessage({ id: 'labelToleranciaRisco' }, {risco: resources.risco}),
                model.getModel('toleranciaRisco')?.value,
                model.getModel('toleranciaRisco')?.requestChange
              )}
            />
          </Col>
        )}

        {visibleFields.includes(
          fields.find((f) => f.id === 'toleranciaRiscoFaixas')
        ) && (
          <Col md={12}>
            <LookupField
              Component={ToleranciaRiscoFaixasLookup}
              clearable
              multi
              highlight={matchesSearch(
                intl.formatMessage({ id: 'labelToleranciaRiscoFaixas' }, {risco: resources.risco}),
                searchQuery
              )}
              model={createLookupModel(
                intl.formatMessage({ id: 'labelToleranciaRiscoFaixas' }, {risco: resources.risco}),
                model.getModel('toleranciaRiscoFaixas')?.value,
                model.getModel('toleranciaRiscoFaixas')?.requestChange
              )}
            />
          </Col>
        )}
      </Row>
    </CollapsibleSection>
  );
};

export default ToleranceSection
